import axios, { AxiosRequestConfig } from 'axios';
import { useSelector } from 'react-redux';
import { sendAssistantCallbackConfirmation } from 'messaging/gql/messagigMutations';
import { gqlUri } from 'core/config/gql/client';
import { messagingSelectors } from 'messaging/redux/messagingSelectors';
import { assistantSettingsProviderSelector } from '../environment/redux/environmentReducer';
import TokenService from 'core/config/gql/TokenService';
import SessionService from 'core/config/gql/SessionService';

const useAxiosSendAssistantConfirmation = () => {
    const tokenInstance = TokenService.getInstance();
    const sessionService = SessionService.getInstance();
    const assistantConversationId = useSelector(messagingSelectors.assistantConversationId);
    const assistantProviderName = useSelector(assistantSettingsProviderSelector);
    const queryBody = sendAssistantCallbackConfirmation.loc?.source.body;

    const sendConfirmation = async (callbackId: string, callbackType: string, confirmed: boolean) => {
        if (tokenInstance.shouldRefreshToken()) {
            await tokenInstance.refreshToken().catch((error) => {
                console.error(`[Token refresh error]: ${error}`);
                sessionService.logoff();
            });
        }

        const token = tokenInstance.getToken();
        const body = {
            query: queryBody,
            variables: {
                data: {
                    assistantProvider: assistantProviderName,
                    assistantConversationId: assistantConversationId,
                    callbackId: callbackId,
                    callbackType: callbackType,
                    confirmed: confirmed,
                },
            },
        };

        const config: AxiosRequestConfig = {
            headers: {
                'X-Auth-Token': `${token}`,
                'Content-Type': 'application/json',
            },
            method: 'post',
            baseURL: gqlUri,
            data: body,
        };

        try {
            await axios(config);
        } catch (error) {
            console.error('error', error);
        }
    };

    return { sendConfirmation };
};

export default useAxiosSendAssistantConfirmation;
